/* eslint-disable */
export { tvLogOverwrite } from './tv';

/**
 * 过滤XSS
 *
 * @param {string}
 *          str
 * @return {}
 */
export function filterXSS (str) {
  return str
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&apos;')
}

function fillBackgroundImage (value) {
  if (value && !/^url/.test(value) && !/^linear\-gradient/.test(value)) {
    return `url(${value})`
  }
  return value
}

export const style2Obj = function (style) {
  if (typeof style !== 'string') {
    return style
  }

  let obj = {}
  style.split(';').forEach(element => {
    if (!element) {
      return
    }

    let items = element.split(':')

    let key = items.shift()
    let value = items.join(':')

    key = key.replace(/^\s*/, '').replace(/\s*$/, '')
    value = value.replace(/^\s*/, '').replace(/\s*$/, '')

    key = key.split('-').map((v, i) => i > 0 ? `${v[0].toUpperCase()}${v.substr(1)}` : v).join('')

    obj[key] = value
  })
  return obj
}

export const isNumber = function (value) {
  return /^[-]?[0-9]*[.]?[0-9]*$/.test(value);
}

const getTransform = function (value, inNativeHippyPage = false) {
  if (!value) return [];

  return Object.entries(value)
    .map(([transformKey, transformValue]) => {
      let defaultValue = 0;
      if (transformKey === 'scale') {
        defaultValue = 1;
      }
      return !inNativeHippyPage ? `${transformKey}(${transformValue || defaultValue})` : { [transformKey]: transformValue || defaultValue }
    });
}

export const transformStyle = function (style, Vue, inNativeHippyPage, base = 375) {
  const [appConfig] = window.magicUiconfig || [];
  if (!style) {
    return {}
  }

  let styleObj = {}
  let results = {}

  if (typeof style === 'string') {
    styleObj = style2Obj(style)
  } else {
    styleObj = { ...style }
  }

  const whiteList = ['zIndex', 'opacity', 'fontWeight'];
  if (inNativeHippyPage) {
    const { window } = Vue.Native.Dimensions;
    const { width } = window;
    Object.entries(styleObj).forEach(([key, value]) => {
      key = toHump(key);
      if (key === 'scale' && !results.transform) {
        results.transform = [ { scale: value } ]
      } else if (key === 'transform' && typeof value !== 'string') {
        results[key] = getTransform(value, inNativeHippyPage);
      } else if (!whiteList.includes(key) && value && /^[-]?[0-9]*[.]?[0-9]*$/.test(value)) {
        results[key] = parseInt(`${(value * width) / base}`, 10);
      } else {
        results[key] = value;
      }
    });
  } else {
    // 居中显示
    if (styleObj._magic_position_align_center && isNumber(style.width)) {
      const halfWidth = (styleObj.width / 2) / 100;
      const centerCalc = `calc(50% - ${halfWidth}rem)`;
      if (isNumber(styleObj.left)) {
        styleObj.left = centerCalc;
      } else if (isNumber(styleObj.right)) {
        styleObj.right = centerCalc;
      }
    }

    Object.entries(styleObj).forEach(([key, value]) => {
      if (key === 'backgroundImage') {
        value && (results[key] = fillBackgroundImage(value));
      } else if (key === 'transform' && typeof value !== 'string') {
        results[key] = getTransform(value, inNativeHippyPage).join(' ');
      } else if (!whiteList.includes(key) && value && /^[-]?[0-9]*[.]?[0-9]*$/.test(value)) {
        if(appConfig?.isPxStyle) {
          results[key] = `${value}px`;
        }else {
          results[key] = `${value / 100}rem`;
        }
      } else {
        results[key] = value;
      }
    });
  }

  return results
}

export const asyncLoadJs = (() => {
  // 正在加载或加载成功的存入此Map中
  const loaded = new Map()

  return (url, crossorigin, document = window.document) => {
    // 正在加载或已经加载成功的，直接返回
    if (loaded.get(url)) return loaded.get(url)

    const load = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      if (crossorigin) {
        script.crossorigin = crossorigin;
      }
      script.src = url;
      document.body.appendChild(script);
      script.onload = () => {
        resolve();
      };
      script.onerror = () => {
        reject(new Error('加载失败'));
      };
      setTimeout(() => {
        reject(new Error('timeout'))
      }, 60 * 1000)
    }).catch(err => {
      // 加载失败的，从map中移除，第二次加载时，可以再次执行加载
      loaded.delete(url)
      throw err
    })

    loaded.set(url, load)
    return loaded.get(url)
  }
})();

export const asyncLoadCss = function (url) {
  return new Promise((resolve, reject) => {
    const hasLoaded = window.document.querySelector(`link[href="${url}"]`);
    if (hasLoaded) {
      resolve();
      return;
    }
    const node = document.createElement('link');
    node.rel = 'stylesheet';
    node.href = url;
    window.document.head.appendChild(node);
    node.onload = resolve;
    node.onerror = reject;
  });
};

/**
   * 截取字符串
   * @param {string} str
   * @param {number} len
   * @return {string}
   */
export function cutStrWithEmoji (str, len) {
  let length = 0
  let strArr = Array.from(str) // ES6的Array.from支持代理对的解析
  let strArrlen = strArr.length
  let result = ''

  for (let i = 0; i < strArrlen; i++) {
    let item = strArr[i]
    length++
    if (escape(item).length > 4) {
      // 中文或表情符编码后长度大于4，按两个字符的宽度计算
      length++
    }
    result = result.concat(item)
    if (length >= len) {
      if (i === strArrlen - 1) {
        return result
      }
      result = result.concat('...')
      return result
    }
  }
  if (length < len) {
    return str
  }
}

export function getSearchObj (search) {
  search = search || (location.search ? location.search.substring(1) : '')

  return search.split('&').reduce((obj, item) => {
    let [a, b = ''] = item.split('=')
    return {...obj, [a]: b}
  }, {})
}

// 包名转驼峰名
export function makeCpntName(name) {
  if (typeof name !== 'string') {
    return ''
  }
  return name.replace(/^@\w*\//, '').replace(/(^|-)(\w)/g, function ($0, $1, $2) {
    return $2.toUpperCase()
  })
}

export function isIPhoneX () {
  if (typeof window !== 'undefined' && window) {
    const isIOS = /iphone/gi.test(window.navigator.userAgent)
    return isIOS && window.screen.height >= 812
  }
  return false
}

// 驼峰转换横线
export const toLine = (name) => {
  return name.replace(/([A-Z])/g, '-$1').toLowerCase();
};

// 横线转换驼峰
export const toHump = (name) => {
  return name.replace(/-(\w)/g, (all, letter) => letter.toUpperCase());
};


/**
 * 从URL中获取指定的参数值
 *
 * @param {String}
 *          p url参数
 * @param {String}
 *          u url 默认为当前url，可为空，如果传入该变量，将从该变量中查找参数p
 * @return {String} 返回的参数值
 */
export function getUrlParam (p, u) {
  u = u || location.href
  const reg = new RegExp(`[?&#]${p}=([^&#]+)`, 'gi')

  const matches = u.match(reg)
  let strArr
  if (matches && matches.length > 0) {
    strArr = matches[matches.length - 1].split('=')
    if (strArr && strArr.length > 1) {
      // 过滤XSS字符
      return filterXSS(strArr[1])
    }
    return ''
  }
  return ''
}

/**
 * 设置url中指定的参数
 *
 * @param {string}
 *          name [参数名]
 * @param {string}
 *          value [参数值]
 * @param {string}
 *          url [发生替换的url地址|默认为location.href]
 * @return {string} [返回处理后的url]
 */
export function setUrlParam (name, value, url) {
  url = url || location.href
  const reg = new RegExp(`[?&#]${name}=([^&#]*)`, 'gi')

  const matches = url.match(reg)

  const key = `{key${new Date().getTime()}}`
  let strArr

  if (matches && matches.length > 0) {
    strArr = matches[matches.length - 1]
  } else {
    strArr = ''
  }

  const extra = `${name}=${value}`

  // 当原url中含有要替换的属性:value不为空时，仅对值做替换,为空时，直接把参数删除掉
  if (strArr) {
    const first = strArr.charAt(0)
    url = url.replace(strArr, key)
    url = url.replace(key, value ? first + extra : '')
  } else if (value) {
    // 当原url中不含有要替换的属性且value值不为空时,直接在url后面添加参数字符串
    if (url.indexOf('?') > -1) {
      url += `&${extra}`
    } else {
      url += `?${extra}`
    }
  }
  // 其它情况直接返回原url
  return url
}

export function delQueStr (url, ref) {
  let str = ''
  if (url.indexOf('?') !== -1) {
    str = url.substr(url.indexOf('?') + 1)
  } else {
    return url
  }
  let arr = ''
  let returnurl = ''
  // const setparam = "";
  const isHit =
    Object.prototype.toString.call(ref) === '[object Array]'
      ? function (v) {
        return ~ref.indexOf(v)
      }
      : function (v) {
        return v === ref
      }
  if (str.indexOf('&') !== -1) {
    arr = str.split('&')
    for (let i = 0, len = arr.length; i < len; i++) {
      if (!isHit(arr[i].split('=')[0])) {
        returnurl = `${returnurl + arr[i].split('=')[0]}=${
          arr[i].split('=')[1]
        }&`
      }
    }

    return returnurl
      ? `${url.substr(0, url.indexOf('?'))}?${returnurl.substr(
        0,
        returnurl.length - 1
      )}`
      : url.substr(0, url.indexOf('?'))
  } else {
    arr = str.split('=')
    if (isHit(arr[0])) {
      return url.substr(0, url.indexOf('?'))
    } else {
      return url
    }
  }
}

export function dateFormat(fmt, date) {
  let ret;
  const opt = {
    'Y+': date.getFullYear().toString(), // 年
    'm+': (date.getMonth() + 1).toString(), // 月
    'd+': date.getDate().toString(), // 日
    'H+': date.getHours().toString(), // 时
    'M+': date.getMinutes().toString(), // 分
    'S+': date.getSeconds().toString() // 秒
  };
  for (let k in opt) {
    ret = new RegExp('(' + k + ')').exec(fmt);
    if (ret) {
      fmt = fmt.replace(ret[1], (ret[1].length === 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, '0')));
    }
  }
  return fmt;
}
